import React from 'react';
import { Event } from '../types';
import './EventTable.css';

interface EventTableProps {
  events: Event[];
  onEventClick: (event: Event) => void;
}

export const EventTable: React.FC<EventTableProps> = ({ events, onEventClick }) => {
  const getSeverityClass = (severity?: string) => {
    switch (severity) {
      case 'high':
        return 'severity--high';
      case 'medium':
        return 'severity--medium';
      case 'low':
        return 'severity--low';
      default:
        return '';
    }
  };

  const getActionClass = (action: string) => {
    switch (action) {
      case 'TRAP_SPAWNED':
        return 'action--trap';
      case 'REROUTE':
        return 'action--reroute';
      case 'SUSPICIOUS_BEHAVIOR':
        return 'action--suspicious';
      case 'COMMAND_EXECUTED':
        return 'action--command';
      default:
        return 'action--normal';
    }
  };

  const formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  return (
    <div className="event-table-container">
      <table className="event-table">
        <thead>
          <tr>
            <th>Time</th>
            <th>IP Address</th>
            <th>Action</th>
            <th>Path</th>
            <th>Session ID</th>
            <th>Severity</th>
            <th>Trap Type</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {events.length === 0 ? (
            <tr>
              <td colSpan={8} className="no-events">
                Waiting for events...
              </td>
            </tr>
          ) : (
            events.map((event) => (
              <tr
                key={event.id}
                onClick={() => onEventClick(event)}
                className={`event-row ${getActionClass(event.action)}`}
              >
                <td className="event-time">{formatTimestamp(event.timestamp)}</td>
                <td className="event-ip">{event.sourceIp}</td>
                <td className={`event-action ${getActionClass(event.action)}`}>
                  <span className="action-badge">{event.action}</span>
                </td>
                <td className="event-path">{event.path}</td>
                <td className="event-session">{event.sessionId}</td>

                <td>
                  {event.severity && (
                    <span className={`severity-badge ${getSeverityClass(event.severity)}`}>
                      {event.severity.toUpperCase()}
                    </span>
                  )}
                </td>

                <td className="event-trap">
                  {event.trapType && <span className="trap-badge">{event.trapType}</span>}
                </td>

                <td>
                  {event.status && (
                    <span className={`status-badge status--${event.status.toLowerCase()}`}>
                      {event.status}
                    </span>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
